import { languageName } from "../../utils/helpers";

// The API's translation limits, mirrored (JS cannot import them); `translationLimits.test.js` fails
// when one drifts from its source.
// `CARD_SUMMARY_MAX_CHARS` (shared/constants/translation.py): the card's line. A card summary whose
// source fits keeps fitting, which is what `over_limit` checks.
export const CARD_SUMMARY_MAX_CHARS = 90;
// `LENGTH_RATIO_RANGE` (shared/services/translation.py): the `length_ratio` check's bounds.
export const LENGTH_RATIO_RANGE = [0.6, 1.6];
// `MAX_RETRANSLATE_ROWS` (domains/admin/service.py): one Retranslate click sends at most this many calls.
export const MAX_RETRANSLATE_ROWS = 25;

// What a `review_reason` code means, in words (#839). The codes are the API's post-checks
// (`check_translation`, `judge_reply`), provider failures (`provider:<kind>`) and `retranslated`; one the map does
// not know is shown as it is, so a new check is never hidden.
const REASONS = {
  wrong_language: (value, locale) => `Reads as ${languageName(value)}, not ${languageName(locale)}`,
  length_ratio: (value) =>
    `${Number(value).toLocaleString()}× the source's length (expected ${LENGTH_RATIO_RANGE.join("–")}×)`,
  over_limit: (value) => `${value} characters; a card summary fits ${CARD_SUMMARY_MAX_CHARS}`,
  refusal: () => "The model refused instead of translating",
  untranslated: (_value, locale) => `Returned unchanged, but the text isn't ${languageName(locale)}`,
  incomplete: (value) => `The reply was cut off (${value})`,
  empty: () => "The reply was empty",
  unreadable_reply: () => "The reply could not be read",
  provider: (value) => `The provider failed (${value})`,
  // Not a check: a bulk Retranslate's result that passed them all, stored for review (#839).
  retranslated: () => "Retranslated; awaiting review",
};

export function reviewReasonLabel(code, locale) {
  if (!code) return null;
  const separator = code.indexOf(":");
  const name = separator === -1 ? code : code.slice(0, separator);
  const value = separator === -1 ? "" : code.slice(separator + 1);
  const describe = REASONS[name];
  return describe ? describe(value, locale) : code;
}
